var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useLayoutEffect } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { setHeaderConfig } from 'fk-cp-common-components/actions/headerContentActions';
var WithWebHeader = function (Component) { return withRouter(connect(mapStateToProps)(function (_a) {
    var _b;
    var dispatch = _a.dispatch, isNativeHeaderHidden = _a.isNativeHeaderHidden, isWebHeaderHidden = _a.isWebHeaderHidden, props = __rest(_a, ["dispatch", "isNativeHeaderHidden", "isWebHeaderHidden"]);
    var enableWebHeaderOnApps = (_b = window.jsFlags) === null || _b === void 0 ? void 0 : _b.enableWebHeaderOnApps;
    var children = props.children, _c = props.showClose, showClose = _c === void 0 ? false : _c, onBack = props.onBack, dynamicContents = props.dynamicContents, hideDynamicContents = props.hideDynamicContents, iosBackPressEnabled = props.iosBackPressEnabled;
    // THis is accessed by the central web header
    window.__ACTION_PROPS__ = props.actionProps;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect(function () {
        if (enableWebHeaderOnApps && !isNativeHeaderHidden) {
            var hideToolBarAndSetStatusBarColor = function () {
                return new Promise(function (resolve, reject) {
                    try {
                        window.Android && typeof window.Android.changeToolBarVisibility === "function" && window.Android.changeToolBarVisibility(true);
                        window.Android && typeof window.Android.setCustomToolBarTheme === "function" && window.Android.setCustomToolBarTheme("#ffffff", true);
                        typeof window.ios === "function" && window.ios('changeToolBarVisibility', {
                            hidden: true,
                            addTopSafeAreaForCustomToolBar: true
                        });
                        typeof window.ios === "function" && window.ios('setCustomToolBarTheme', {
                            actionBarColor: "#ffffff",
                            applyLightTheme: true
                        });
                        setTimeout(function () { return resolve(true); }, 100); // 100ms delay so that the native header is hidden before the web header is rendered
                    }
                    catch (e) {
                        console.error("Error in hideToolBarAndSetStatusBarColor", e);
                        reject(false);
                    }
                });
            };
            hideToolBarAndSetStatusBarColor().then(function () { return dispatch(setHeaderConfig({ isNativeHeaderHidden: true, isWebHeaderHidden: false })); }).catch(console.error);
        }
    }, [enableWebHeaderOnApps, isNativeHeaderHidden, dispatch]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
        if (enableWebHeaderOnApps && dispatch && isNativeHeaderHidden && !isWebHeaderHidden) {
            // Update the header redux state when header data changes
            var config = {};
            config.title = children || "";
            config.showClose = showClose;
            config.iosBackPressEnabled = iosBackPressEnabled;
            if (onBack) {
                // Convert function to action type - you may want to customize this logic
                config.onBackAction = onBack;
            }
            config.portalDomNode = "web-header-placeholder";
            if (!hideDynamicContents && dynamicContents) {
                config.dynamicContents = dynamicContents;
            }
            dispatch(setHeaderConfig(config));
        }
        return function () {
            if (enableWebHeaderOnApps && dispatch && isNativeHeaderHidden) {
                // Reset header redux state when component unmounts
                dispatch(setHeaderConfig({
                    title: "",
                    showClose: false,
                    iosBackPressEnabled: false,
                    onBackAction: null,
                    portalDomNode: "",
                    dynamicContents: []
                }));
            }
        };
    }, [children, showClose, onBack, dynamicContents, hideDynamicContents, enableWebHeaderOnApps, dispatch, isNativeHeaderHidden, isWebHeaderHidden, iosBackPressEnabled]);
    return (enableWebHeaderOnApps && isNativeHeaderHidden ? <div id="web-header-placeholder"/> : <Component {...props}/>);
})); };
var mapStateToProps = function (state) {
    var _a, _b;
    return ({
        isNativeHeaderHidden: (_a = state.selfServe.headerContent) === null || _a === void 0 ? void 0 : _a.isNativeHeaderHidden,
        isWebHeaderHidden: (_b = state.selfServe.headerContent) === null || _b === void 0 ? void 0 : _b.isWebHeaderHidden
    });
};
export default WithWebHeader;
